import React, { useState, useEffect } from 'react';
import { Space, Progress, Typography } from 'antd';
import { callAnalyticsAPI } from '../../../services/callAnalytics';

const { Text } = Typography;

const QueueStatusBar = ({ children }) => {
  const [queueStats, setQueueStats] = useState(null);

  useEffect(() => {
    loadQueueStats();
  }, []);

  // Auto-refresh when there are active or waiting jobs
  useEffect(() => {
    const hasActiveJobs = queueStats && (queueStats.active > 0 || queueStats.waiting > 0);
    if (!hasActiveJobs) return;

    const interval = setInterval(() => {
      loadQueueStats();
    }, 5000); // Refresh every 5 seconds

    return () => clearInterval(interval);
  }, [queueStats]);

  const loadQueueStats = async () => {
    try {
      // Get actual transcription status counts from database
      const recordings = await callAnalyticsAPI.getRecordings({ 
        limit: 1000,
        transcriptionStatus: null
      });
      
      // Count by status
      const stats = {
        waiting: recordings.recordings.filter(r => r.transcriptionStatus === 'pending').length,
        active: recordings.recordings.filter(r => r.transcriptionStatus === 'processing').length,
        completed: recordings.recordings.filter(r => r.transcriptionStatus === 'completed').length,
        failed: recordings.recordings.filter(r => r.transcriptionStatus === 'failed').length
      };
      
      setQueueStats(stats);
    } catch (error) {
      console.error('Queue stats error:', error);
    }
  };

  const getQueueProgress = () => {
    if (!queueStats) return 0;
    const total = queueStats.waiting + queueStats.active + queueStats.completed;
    if (total === 0) return 0;
    return Math.round((queueStats.completed / total) * 100);
  };

  if (!queueStats) {
    return null;
  }

  return (
    <div style={{ 
      padding: '16px 20px', 
      background: '#fafafa', 
      borderRadius: '12px',
      marginBottom: '16px',
      border: '1px solid #f0f0f0'
    }}>
      <Space direction="vertical" style={{ width: '100%' }} size="middle">
        <Space style={{ width: '100%', justifyContent: 'space-between' }}>
          <Space size="large">
            <Text strong style={{ fontSize: '15px' }}>Queue Status</Text>
            <Progress 
              percent={getQueueProgress()} 
              status={queueStats.active > 0 ? 'active' : 'normal'}
              format={() => `${queueStats.completed} / ${queueStats.waiting + queueStats.active + queueStats.completed}`}
              style={{ width: '200px' }}
              strokeWidth={8}
            />
          </Space>
          {children && (
            <Space size="middle">
              {children}
            </Space>
          )}
        </Space>
        <Space size="middle" style={{ paddingLeft: '0px' }}>
          <Text>
            <span style={{ color: '#1890ff', fontWeight: '500' }}>Waiting:</span> {queueStats.waiting}
          </Text>
          <Text>
            <span style={{ color: '#faad14', fontWeight: '500' }}>Processing:</span> {queueStats.active}
          </Text>
          <Text>
            <span style={{ color: '#52c41a', fontWeight: '500' }}>Completed:</span> {queueStats.completed}
          </Text>
          {queueStats.failed > 0 && (
            <Text>
              <span style={{ color: '#ff4d4f', fontWeight: '500' }}>Failed:</span> {queueStats.failed}
            </Text>
          )}
        </Space>
      </Space>
    </div>
  );
};

export default QueueStatusBar;
